import { attachValidation } from './forms/validation.js';
import { handleFormSubmit } from './forms/handleSubmit.js';
import { setupFormShowLogic } from './forms/formShowLogic.js';
import { formConfigs } from './forms/configs.js';

const formEventListeners = new WeakMap();

export function removeExistingEventListeners(formElement) {
  const existingListener = formEventListeners.get(formElement);
  if (existingListener) {
    formElement.removeEventListener('submit', existingListener);
    formEventListeners.delete(formElement);
  }
}

export function attachFormEventListener(formElement, handler) {
  removeExistingEventListeners(formElement);
  formEventListeners.set(formElement, handler);
  formElement.addEventListener('submit', handler);
}

export default function initFormHandler() {
  const formControl = document.getElementById('formControl');

  if (!formControl) return;

  const setupForm = (formWrapper, formKey) => {
    const form = formWrapper.querySelector('form');
    const config = formConfigs[formKey];
    if (!form || !config) return;

    attachValidation(form, config.schema, config.errorMapping, (validatedForm) => {
      handleFormSubmit(validatedForm, config.endpoint);
    });

    attachFormEventListener(form, (e) => {
      e.preventDefault();
      handleFormSubmit(form, config.endpoint);
    });

    const prefix = form.dataset.prefix;
    const formClass = [...form.classList].find(cls => cls !== 'contact-form');
    if (prefix && formClass) {
      setupFormShowLogic({ prefix, formClass });
    }
  };

  formControl.addEventListener('change', () => {
    const selected = formControl.value;
    const allForms = document.querySelectorAll('.contact-form-partial');
    allForms.forEach(f => f.style.display = 'none');

    const selectedWrapper = document.getElementById(selected);
    if (selectedWrapper) {
      selectedWrapper.style.display = 'block';
      setupForm(selectedWrapper, selected);
    }
  });

  // Initial default form setup
  const defaultWrapper = document.getElementById('Accessibility');
  if (defaultWrapper) {
    defaultWrapper.style.display = 'block';
    setupForm(defaultWrapper, 'Accessibility');
  }
}

// Initialize the contact form
initFormHandler();

